var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysShoppingAddCart = function SvgSysShoppingAddCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#sysShoppingAddCart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67 21.844a1.463 1.463 0 1 0 0-2.926 1.463 1.463 0 0 0 0 2.926ZM19.256 21.844a1.463 1.463 0 1 0 0-2.926 1.463 1.463 0 0 0 0 2.926ZM.959 1.137h3.852l2.58 12.894a1.926 1.926 0 0 0 1.927 1.55h9.36a1.925 1.925 0 0 0 1.925-1.55l1.541-8.079M13.715 4.5v5.417M11.006 7.208h5.416"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysShoppingAddCart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .167h23.111v23.11H0z"
  })))));
};
export default SvgSysShoppingAddCart;